import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { fonts } from '../common/mixins.js';

const baseUrl =
    'https://travel.more.com/cmstemplates/vivatravelaspx/data/common/barcode.ashx?linewidth=7&fontsize=30&height=140&hidetext=true&code=';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

const Image = styled.div`
  width: 100%;
  height: ${(props) => (props.isQr ? '106px' : '47.6px')};
  background-image: ${(props) => `url(${props.url})`};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

const Number = styled.div`
  ${fonts.normalTextSmall()};
`;

export default function Barcode({ code, eventId }) {
    const isQr = eventId === 821377;
    const url = isQr
        ? `${baseUrl}${code}&type=qrcode`
        : `${baseUrl}${code}`;

    return (
        <Container className="items-barcode">
            <Image url={url} isQr={isQr} />
            <Number id="barcodeNumber">{code}</Number>
        </Container>
    );
}
